import useSettingsChange from "@components/Pages/Machines/useSettingsChange";
import { DeleteMinerNotes_RequestTypes, SetMinerNotes_RequestTypes } from "@mobx/api/minerNotes";
import apiService, { createRequestControl } from "@mobx/services/http";
import { useAuth } from "@utils/hooks/useAuth";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMinerContext } from "../../MinerContext";
import { MinerActions } from "../../minerReducer";
import { MyFormMinerSettings } from "../MyForm";
import { formatMinerMeta, IMinerMeta } from "@services/changeMinerSettings";

export interface INotesFormProps {
  value?: string;
  type: "admin_note" | "user_note" | "sync_note";
  editable?: boolean;
}

const setMinerNote = apiService.createRequest(SetMinerNotes_RequestTypes);
const deleteMinerNote = apiService.createRequest(DeleteMinerNotes_RequestTypes);
const rc = createRequestControl();

export function useNotesControl({ value, type }: INotesFormProps) {
  const auth = useAuth();
  const form = useRef<HTMLFormElement>(null);
  const textArea = useRef<HTMLTextAreaElement>(null);
  const { miner, dispatchMiner } = useMinerContext();
  const { saveNote } = useSettingsChange(miner.id.toString());
  const [currentValue, setCurrentValue] = useState<string>("");
  const [changed, setChanged] = useState(0);
  const [edit, setEdit] = useState<boolean>(false);

  const onChangeValue = (v: string) => setCurrentValue(v);
  useEffect(() => () => rc.abortAllRequests(), []);

  useEffect(() => {
    setCurrentValue(value || "");
  }, [value]);

  const onSubmit = async (e: React.FormEvent<MyFormMinerSettings>) => {
    e.preventDefault();
    if (type === "sync_note") return;
    const note = e.currentTarget.elements["notes_text"]?.value;
    const r = await setMinerNote(rc.createRequestHandle(), miner.id, note);
    if (!r) return;
    setCurrentValue(note);
    setChanged((prev) => prev + 1);
    const saveType = type === "admin_note" ? "a" : "u";
    dispatchMiner({
      type: MinerActions.Notes,
      payload: { type: saveType, value: note },
    });
  };
  const onSubmitByEnter = async (
    e: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    if (e.ctrlKey && e.key === "Enter") {
      setEdit(false);
      form.current?.requestSubmit();
    } else if (e.key === "Escape") {
      setEdit(false);
      onChangeValue(value || "");
    }
  };


  // const appendMetaToAdminComment = useCallback(() => {
  //   const meta = miner.meta;
  //   /* ip, mac, серийный номер, порт, пароль */
  //   if (!meta) return;
  //   const newValue = `${currentValue}\n----\n${formatMinerMeta(meta)}`;
  //   if (textArea.current) {
  //     const newRows = (textArea.current.value.match(/\n/g) || []).length + 1;
  //     if (newRows < textArea.current.rows) {
  //       textArea.current.rows = textArea.current.rows - newRows;
  //     }
  //   }
  //   setCurrentValue(newValue);
  // }, [miner.meta, currentValue]);

  return {
    isAdmin: auth.isAdmin,
    changed,
    currentValue,
    form,
    edit,
    textArea,
    //appendMetaToAdminComment,
    setEdit,
    onSubmit,
    onSubmitByEnter,
    onChangeValue,
  };
}
